import React, {useState, useRef} from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import endpoints, { getBackendUrl } from '../../../endpoints';
import { useSelector, useDispatch } from 'react-redux'
import CloseIcon from '@mui/icons-material/CloseRounded';

export default function EditPromptModal(props) {        
    const data = props.dialogData
    const [errors, setErrors] = useState()
    if (data == null && errors !== null) {
        setErrors(null)
    }
        
    const contentRef = useRef()
    const categoryRef = useRef()
    
    const token = useSelector((state) => state.auth.token)
    
    const save = async () => {
        if (props.dialogData == null) return
        
        const params = {
            content: contentRef.current.value
        }
        
        if (props.dialogType == 'prompt') {
            params.parent_id = categoryRef.current.value
        }
        
        let res = null
        try {
            if (props.dialogData.id) {
                let uri = getBackendUrl(endpoints.prompts_edit, token).replace('{id}', props.dialogData.id)
                res = await axios.put(uri, params)
            } else {
                params.type = props.dialogType
                let uri = getBackendUrl(endpoints.prompts_add, token)
                res = await axios.post(uri, params)
            }
            
            props.onSave()
        } catch (err) {
            if (err.response.data.status == 'invalidate') {
                const e = err.response.data.details;
                for (let i in e) {
                    e[i] = e[i].replace('"content"', props.dialogType == 'prompt' ? '"Prompt Text"' : '"Name"')
                    e[i] = e[i].replace('"parent_id"', '"Category"')
                }
                setErrors(e)
            }
        }
    }

    return (
        <Dialog open={props.dialogData ? true : false} fullWidth maxWidth={props.dialogType == 'prompt' ? 'sm' : 'xs'} onClose={props.onClose}>
            <form onSubmit={(e) => {e.preventDefault()}}>
                <DialogTitle>
                    {props.dialogType == 'prompt' ? 'Prompt Properties' : 'Category Properties'}
                    <IconButton
                        onClick={props.onClose}
                        sx={{
                          position: 'absolute',
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {props.dialogType == 'prompt' ?
                    <FormControl variant="filled" fullWidth >
                        <InputLabel id="categoryLabel">Category</InputLabel>
                        <Select
                            fullWidth
                            labelId="categoryLabel"
                            name="category" 
                            margin="dense"
                            defaultValue={props.category ? props.category.id : ''}
                            inputRef={categoryRef}
                        >
                        {props.categories.map((row) => (
                            <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                        ))}
                        </Select>
                        <FormHelperText>{errors ? errors.parent_id : ''}</FormHelperText>
                    </FormControl>
                    : null }
                    {props.dialogType == 'prompt' 
                    ? 
                    <TextField 
                        id="content"
                        fullWidth
                        margin="dense"
                        name="content"
                        label="Prompt Text"
                        variant="filled" 
                        multiline
                        rows={4}
                        defaultValue={data?.content}
                        inputRef={contentRef}
                        helperText={errors?.content}
                        error={errors?.content}
                    />
                    :
                    <TextField 
                        id="content"
                        fullWidth
                        margin="dense"
                        name="content"
                        label="Name"
                        variant="filled" 
                        rows={1}
                        defaultValue={data?.content}
                        inputRef={contentRef}
                        helperText={errors?.content}
                        error={errors?.content}
                    />      
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button type="submit" onClick={save}>Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}